import { WalletItem } from "../models/wallet-watchlist.models";
import { axiosService } from "./axios.service";

export class WalletWatchlistService {
  static getWalletListRequest = async (): Promise<WalletItem[] | undefined> => {
    const response: WalletItem[] = await axiosService.get(`/user/wallet-list`);
    return response;
  };

  static updateWalletActiveStatus = async (
    walletId: string,
    status: boolean
  ) => {
    const response = await axiosService.post(`/user/wallet-active`, {
      walletId,
      status,
    });

    return response;
  };

  static deleteWalletAddress = async (walletId: string) => {
    const response = await axiosService.delete(
      `/user/delete-wallet/${walletId}`
    );

    return response;
  };

  static addWalletAddressRequest = async (type: string, address: string) => {
    try {
      return await axiosService.post(`/user/add-wallet`, { type, address });
    } catch (error: any) {
      console.error(error);
    }
  };
}
